import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
import * as FormTypes from "MODULES/shared/components/Forms/FormTypes";

import {
  HIGHER_ASSEMBLY_APPLICATION,
  ENGINE_APPLICATION,
  AIRCRAFT_APPLICATION,
  LOWER_ASSEMBLY_APPLICATION,
  PART
} from "MODULES/parts/constants";

import { spaceBetweenCaps } from "LIB/formatters/text";
import { change } from "redux-form";
import Search from "./Search";

const config = {
  [HIGHER_ASSEMBLY_APPLICATION]: {
    label: "Higher Assembly"
  },
  [AIRCRAFT_APPLICATION]: {
    label: "Aircraft"
  },
  [ENGINE_APPLICATION]: {
    label: "Engine"
  },
  [LOWER_ASSEMBLY_APPLICATION]: {
    label: "Lower Assembly"
  }
};

export class Applicable extends Component {
  onChange = e => {
    this.props.input.onChange(null);
    this.props.afterChange(e.target.value);
  };

  onSelect = result => {
    const { input, setFieldValue, type } = this.props;
    const value = (result && result.id) || "";
    if (
      type === LOWER_ASSEMBLY_APPLICATION &&
      [undefined, null, ""].includes(value)
    ) {
      setFieldValue("label")(result);
    }

    input.onChange(value);

    if (value !== input.value) {
      input.onBlur(value);
    }
  };

  render() {
    const { meta, part, type } = this.props;

    const { touched, invalid } = meta;
    const errorClasses = classNames({ "has-error": touched && invalid });

    return (
      <div>
        <div className="form-group">
          <label className="control-label" htmlFor="applicable-type">
            Type
          </label>
          <select
            className="form-control"
            id="applicable-type"
            value={type}
            onChange={this.onChange}
          >
            {[
              AIRCRAFT_APPLICATION,
              ENGINE_APPLICATION,
              HIGHER_ASSEMBLY_APPLICATION,
              LOWER_ASSEMBLY_APPLICATION
            ].map(f => (
              <option value={f}>
                {spaceBetweenCaps(f.replace("Application", ""))}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="applicable">
            {config[type].label}
            <sup className="small text-danger">*</sup>
          </label>
          <div id="applicable" className="input-group">
            <span className="input-group-addon">
              Part #{part.part_number}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <i className="fa fa-exchange" />
            </span>
            <div className={errorClasses}>
              <Search
                type={type}
                onSelect={this.onSelect}
                part={part}
                autoFocus
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Applicable.propTypes = {
  input: PropTypes.oneOfType([FormTypes.numericInput, FormTypes.stringInput])
    .isRequired,
  meta: FormTypes.meta.isRequired,
  afterChange: PropTypes.func.isRequired,
  part: PropTypes.instanceOf(Object).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
};

export default connect(
  state => ({
    part: state.partDetail.get(PART).toJS()
  }),
  (dispatch, ownProps) => ({
    setFieldValue: field => val =>
      dispatch(change(ownProps.formName, field, val))
  })
)(Applicable);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Applications/Applicable/Applicable.jsx